module.exports = __webpack_public_path__ + "static/img/rank_233.c8897b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_233.png
// module id = Wo27
// module chunks = 0